import dayjs from "dayjs";
import { useEffect, useState } from "react";


export interface ClientApprovalGridProps {
  transporter: any;
  deepLink?: { tab?: string; recordId?: string; action?: string };
}

/**
 * Formats the default column name returned from the API.
 * 
 * @param {string} defaultName - The current name from the API.
 * @returns {string} - The final column name to be displayed in the grid.
 */
export const GridColumnTitleRenderer = (defaultName: string): string => {
  return defaultName;
};

/**
 * Formats a datetime string into a readable date format, optionally including time.
 * 
 * @param {Object} params - Object containing formatting options.
 * @param {string} [params.value] - The raw date-time string to format.
 * @param {boolean} [params.showTime=true] - Whether to include time in the output.
 * @returns {string} - A formatted date string (with or without time).
 */
export const TimeRenderer = (params: {
  value?: string;
  showTime?: boolean;
}): string => {
  const { value, showTime = true } = params; // Default showTime to true if not provided

  if (!value) return ""; // Return empty string if value is undefined or null

  // Format the date and time using dayjs
  const formattedDate = dayjs(value).format("MM/DD/YYYY");
  const formattedTime = dayjs(value).format("hh:mm:ss A");

  return showTime ? `${formattedDate} ${formattedTime}` : formattedDate;
};

/**
 * Custom React hook that debounces a value by the specified delay.
 * Useful for optimizing input handlers (e.g., search, filters).
 * 
 * @template T
 * @param {T} value - The value to debounce.
 * @param {number} delay - The debounce delay in milliseconds.
 * @returns {T} - The debounced value.
 */
export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Set timeout to update the debounced value after the delay
    const handler = setTimeout(() => setDebouncedValue(value), delay);

    // Clear timeout if value or delay changes before delay completes
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

  // Helper: read deeplink if prop not provided
export  const parseDeepLinkFromUrl = () => {
    const qs = new URLSearchParams(window.location.search);
    const recordId = qs.get("recordId") || undefined;
    const action = qs.get("action") || undefined;
    return recordId || action ? { recordId, action } : undefined;
  };
